export default {
  getFilter: (state) => state.filter,
  selectedBuyer: state => state.selectedBuyer
}



// WEBPACK FOOTER //
// ./src/store/buyer/getters.js